module.exports = __webpack_public_path__ + "img/newsImg11-7.d288c913.png";